import React from "react";
import "../../index.css";
import "./StandardText.css";

const StandardText = ({
  clr = "white",
  children,
  marginClass,
  widthClass,
  class_Name
}) => {
  return (
    <p className={` standard-text-p ${class_Name && class_Name} ${clr && `${clr}`} ${marginClass && marginClass} ${class_Name && class_Name}`}>{children}</p>
  );
};

export default StandardText;